import { useCallback } from 'react';

import { type FeatureFlagNames } from 'api/configuration/features/FeatureFlagConfigurationSetting';
import { useFeatureFlagsStore } from 'features/configuration/state/featureFlagsStore';
import type { FeatureFlagState } from 'features/configuration/types';
import { devLog } from 'utils/dev-utils';
import type { Nullable } from 'utils/values';

export const useHasFeatureFlag = () => {
  const featureFlags = useFeatureFlagsStore((state) => state.featureFlags);

  return useCallback((name: FeatureFlagNames) => isFeatureFlagEnabled(featureFlags, name), [featureFlags]);
};

export function isFeatureFlagEnabled(featureFlags: Nullable<FeatureFlagState[]>, name: FeatureFlagNames) {
  if (!featureFlags) {
    devLog(`Feature flags are not yet loaded`);
    return false;
  }

  const featureFlag = featureFlags.find((f) => f.name === name);

  if (!featureFlag) {
    devLog(`Feature flag ${name} was not found`);
    return false;
  }

  return featureFlag.enabled;
}
